export const simplifiedOperationalStatus = (status: string) => {
  if (["completed", "closed"].includes(status)) return "completed";
  if (["in_progress", "paused", "pending_completion"].includes(status)) return "in_progress";
  if (["cancelled", "not_performed"].includes(status)) return status;
  return "planned";
};
